import { graphql } from "@/lib/gql/__generated__";

export const RoomI18n_DesignPage_Query = graphql(`
	query RoomI18n_DesignPage($hotelID: ID!, $roomID: ID!, $lang: LangCode!) {
		roomI18n(hotelID: $hotelID, roomID: $roomID, lang: $lang) {
			id
			lang
			hotelID
			roomID
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
			articleTitle
			name
		}
	}
`);
